import { loadScript } from '../load-strategies/FacebookSdkLoader';

export type { IFacebookSdk } from '../load-strategies/FacebookSdkLoader';

export default {
  name: 'facebook',
  loader: loadScript,
};
